import type { AxiosInstance } from 'axios';
import { partial } from 'lodash-es';

import type {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPatchRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from './axiosRequestOptions';
import createRequest from './createRequest';
import type { ApiOf } from './type';

const createApiOf = (axiosInstance: AxiosInstance) => {
  const apiOf = <R extends Dictionary, S extends Dictionary>(
    t:
      | AxiosGetRequestOptions
      | AxiosPatchRequestOptions
      | AxiosPostRequestOptions
      | AxiosDeleteRequestOptions
      | AxiosPutRequestOptions,
  ): ApiOf<R, S> =>
    partial(createRequest, axiosInstance, t) as unknown as ApiOf<R, S>;

  return apiOf;
};

export default createApiOf;
